var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16644 15.6666C0.579559 15.6666 0.187053 15.0815 0.382923 14.5488L0.421084 14.4606L1.38393 12.5349C1.74843 11.8059 1.95566 11.0096 1.99346 10.1974L1.99977 9.92617V7.33329C1.99977 4.85574 3.80176 2.79906 6.1666 2.4024L6.16644 1.49996C6.16644 1.03972 6.53954 0.666626 6.99977 0.666626C7.46001 0.666626 7.83311 1.03972 7.83311 1.49996L7.83378 2.40254C10.1325 2.78852 11.8993 4.74306 11.9956 7.12786L11.9998 7.33329V9.92617C11.9998 10.7412 12.1706 11.5462 12.5 12.2895L12.6156 12.5349L13.5785 14.4606C13.8409 14.9855 13.4931 15.5983 12.9291 15.6613L12.8331 15.6666H8.66644C8.66644 16.5871 7.92025 17.3333 6.99977 17.3333C6.0793 17.3333 5.33311 16.5871 5.33311 15.6666H1.16644ZM6.99977 3.99996C5.21461 3.99996 3.75721 5.40327 3.67052 7.16693L3.66644 7.33329V9.92617C3.66644 10.9935 3.43865 12.0474 2.99961 13.0177L2.87464 13.2803L2.5148 14H11.4847L11.1249 13.2803C10.6476 12.3256 10.38 11.2812 10.3387 10.2169L10.3331 9.92617V7.33329C10.3331 5.49234 8.84072 3.99996 6.99977 3.99996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.ee484219.svg";
export { ForwardRef as ReactComponent };